import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';

import { LoginService } from '../shared/login.service';

import { AlertService } from './alert/alert.service';

import {
  MODAL_MESSAGES
} from '../shared/constants';
import { TranslateService } from 'ng2-translate/ng2-translate';

@Injectable()
export class ExceptionService {
  message: string;
  title: string;

  constructor(
    private router: Router,
    private loginService: LoginService,
    private alertService: AlertService,
    private translator: TranslateService,
  ) { }

  translateMessages(){
    this.translator.get('modal').subscribe((res) => {
      this.message = res.messages['session-title'];
      this.title = res.messages['session-text'];
    })
  }
  catchBadResponse: (errorResponse: any) => Observable<any> = (errorResponse: any) => {
    console.log('Catch!', errorResponse)
    let res = <Response>errorResponse;
    let err = res.json();
    let emsg = err ?
      (err.error ? err.error : JSON.stringify(err)) :
      (res.statusText || 'unknown error');
    // this.toastService.activate(`Error - Bad Response - ${emsg}`);
    console.warn(`Error - Bad Response - ${emsg}`);

    if (err.serviceStatus.code === 403) {
      let message = this.message;
      let title = this.title;
      let okText = 'OK';

      this.alertService
        .activate(message, title, okText, '')
        .then((response) => {
          this.loginService.logout();
          return Observable.of(false);
        });
    } else {
      return Observable.of(false);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/exception.service.ts